module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('transition', {
    attrs: {
      "name": "fade-down"
    }
  }, [(_vm.showIt) ? _c('div', {
    staticClass: "vw-info",
    class: {
      'vw-info__success': _vm.type === 'success', 'vw-info__warn': _vm.type === 'warn'
    }
  }, [_c('div', {
    staticClass: "vw-info-container"
  }, [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-3d6863a6!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/info.vue
// module id = 231
// module chunks = 0